import { NOTIFICATIONS_CHANNEL } from '@app/constants/channels'
import { closeChannel, openChannel } from '@app/actions/notifications/notificationsChannel'
import openCable from '../cable'

const notificationsChannel = ({ request, response }) => {
  const cable = openCable()
  if (!cable) return null

  let subscription = cable.subscriptions.consumer.subscriptions.subscriptions.find((sub) => sub.identifier.includes('NotificationsChannel'))
  if (!subscription) {
    subscription = cable.subscriptions.create(NOTIFICATIONS_CHANNEL, {
      connected() {
        request(this)
        store.dispatch(openChannel())
      },
      received(data) {
        response(data)
      },
      disconnected: () => {
        store.dispatch(closeChannel())
      },
    })
  }
  return subscription
}

export default notificationsChannel
